<nav class="venta-list" *ngIf="pasos && pasos.length">
  <ul>
    <li
      *ngFor="let paso of pasos; index as i"
      routerLinkActive="current"
      [class.hidden]="!paso.visible ? true : null"
    >
      <div
        (click)="navegar(paso.url)"
        title="{{ paso.nombre }}"
        style="cursor: pointer"
      >
        {{ paso.nombre | translate | uppercase }}
      </div>
      <span *ngIf="i >= 0 && i !== pasos.length - 1" [class.hidden]="!paso.visible ? true : null">/</span>
    </li>
  </ul>
</nav>